import axios from 'axios';
import { base_url } from './api-config';

const getHeaders = (operation: string, key_id?: number) => {
    let header: any = {
        "Content-Type": "application/json",
        "operation": operation
    };
    if (key_id && key_id !== undefined && key_id !== null) {
        header["key-id"] = key_id;
    }

    return {
        headers: header
    };
};

/*
 * Phase 7C-6C follow-up (2026-09-08): the localStorage fallback is gone.
 *
 * This module used to carry five invented expenses (`SEED_EXPENSES`,
 * recorded by "ผู้จัดการ ร้านค้า" and "แคชเชียร์หน้าร้าน"), a localStorage
 * copy of the data, and a full CRUD mock that answered from that copy
 * whenever the API call failed -- reads AND writes. The gate that was
 * meant to keep it out of real use checked only for `localhost`, so on
 * the Pilot LAN host a Backend hiccup silently turned the expense screen
 * into a demo that looked identical to the real thing, and saved the
 * shop's entries into the browser.
 *
 * Nothing here reads or writes browser storage any more. Every row the
 * screen shows came from Backend, or the screen shows nothing.
 *
 * Errors are passed through, not translated: `expense-category-modal`
 * reads `e.response.data.message` to show the Backend's own wording
 * (for instance a duplicate category code), and the auth interceptor
 * needs the 401 untouched. Only a failure with no response at all --
 * offline, DNS, timeout -- becomes a plain Error with a message the
 * screen can show.
 */

const CONNECTION_FAILED = 'ไม่สามารถเชื่อมต่อ Backend สำหรับข้อมูลค่าใช้จ่ายได้ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่อีกครั้ง';

const post = async (route: string, operation: string, body: any, key_id?: number): Promise<any> => {
    let res;
    try {
        res = await axios.post(`${base_url}${route}`, JSON.stringify(body ?? {}), getHeaders(operation, key_id));
    } catch (e: any) {
        if (e?.response) {
            throw e;
        }
        throw new Error(CONNECTION_FAILED);
    }
    if (res && res.status === 200 && res.data !== undefined && res.data !== null) {
        return res.data;
    }
    // A 200 carrying nothing usable is not a reason to invent data either.
    throw new Error(`Backend ส่งผลลัพธ์ ${String(operation).toUpperCase()} ที่ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง`);
};

export const api_expense = (operation: string, body: any, key_id?: number): Promise<any> =>
    post('/api/v1/expense', operation, body, key_id);

export const api_expense_category = (operation: string, body: any, key_id?: number): Promise<any> =>
    post('/api/v1/expense/category', operation, body, key_id);
